import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import "./index.css";

// ------------------------------
// Cognito OIDC Configuration
// ------------------------------
const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_URL,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  logout_uri: process.env.REACT_APP_REDIRECT_SIGNOUT,
  post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_SIGNOUT,
  response_type: "code",
  scope: "openid email phone profile",
  loadUserInfo: false,
  automaticSilentRenew: false,
  monitorSession: false,
  metadata: {
    issuer:
      "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_Mt6u6mkMp",
    authorization_endpoint:
      "https://ap-southeast-2mt6u6mkmp.auth.ap-southeast-2.amazoncognito.com/oauth2/authorize",
    token_endpoint:
      "https://ap-southeast-2mt6u6mkmp.auth.ap-southeast-2.amazoncognito.com/oauth2/token",
    userinfo_endpoint:
      "https://ap-southeast-2mt6u6mkmp.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo",
    end_session_endpoint:
      "https://ap-southeast-2mt6u6mkmp.auth.ap-southeast-2.amazoncognito.com/logout",
  },
};

// ------------------------------
// Start React AFTER SW is ready
// ------------------------------
function startReact() {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  );
}

// ------------------------------
// Service Worker Registration
// ------------------------------
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then(() => navigator.serviceWorker.ready)
    .then(() => {
      console.log("SW ready � starting React");
      startReact();
    })
    .catch((err) => {
      console.warn("SW registration failed:", err);
      startReact(); // fallback
    });
} else {
  startReact();
}